require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./art-et-culture-1-8.json") })
        }
      }, "path---art-et-culture-1-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---art-et-culture-1-8!./.cache/json/art-et-culture-1-8.json
// module id = 334
// module chunks = 231608221292675